import { isAdminDesignRoutePathname } from '@bettermode/domain/routes/web/admin'
import { useRouterPath } from '@tribeplatform/react-sdk'

import { RouteMode } from './modes/index.js'

export function useMode(): RouteMode {
  const pathname = useRouterPath()

  if (pathname.startsWith('/settings/moderation')) {
    return 'moderation'
  }

  if (isAdminDesignRoutePathname(pathname)) {
    return 'design'
  }

  return 'admin'
}
